import React, { useContext } from "react";
import { WorkspaceContext } from "../context/WorkspaceContext";

export function formatRunId(runId) {
  if (!runId) return "";
  const match = runId.match(/^RUN-(\d{4})(\d{2})(\d{2})-(\d{4})/i);
  return match ? `RUN-${match[1]}/${match[2]}/${match[3]}-${match[4]}` : runId;
}

export default function Runs() {
  const {
    activeRepoProject,
    currentUser,
    downloadLog,
    dynamicTotalScenarios,
    playRunVideo,
    reportsList,
    setActiveRepoProject,
    setPage,
    setRunProject,
    setRunTestCase,
    setRunTriggeredBy,
    setSaveProject,
    setShowStartRunModal,
    testCaseRepo,
    setExpandedCodeTestId,
    setExpandedRepoTab,
    fetchTestCases
  } = useContext(WorkspaceContext);

  // Sort runs by timestamp descending (most recent first)
  const sortedReportsList = [...(reportsList || [])].sort((a, b) => {
    const ta = a.timestamp || a.run_id || "";
    const tb = b.timestamp || b.run_id || "";
    return tb.localeCompare(ta);
  });

  return (

            <div>

              {/* Colorful Runs Summary Cards */}

              <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: "20px", marginBottom: "24px" }}>

                <div style={{ background: "#fff7ed", borderRadius: "12px", padding: "20px", color: "#7c2d12", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.05)", border: "1px solid #fed7aa", textAlign: "left" }}>

                  <div style={{ fontSize: "11px", fontWeight: "700", textTransform: "uppercase", color: "#c2410c", letterSpacing: "0.5px" }}>Total Test Scripts</div>

                  <div style={{ fontSize: "28px", fontWeight: "800", marginTop: "8px" }}>

                    {Object.values(testCaseRepo || {}).reduce((acc, curr) => acc + (curr ? curr.length : 0), 0)}

                  </div>

                </div>

                <div style={{ background: "#ffffff", borderRadius: "12px", padding: "20px", color: "#1e293b", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.05)", border: "1px solid #e2e8f0", textAlign: "left" }}>

                  <div style={{ fontSize: "11px", fontWeight: "700", textTransform: "uppercase", color: "#C2410C", letterSpacing: "0.5px" }}>Test Cases</div>

                  <div style={{ fontSize: "28px", fontWeight: "800", marginTop: "8px" }}>{dynamicTotalScenarios}</div>

                </div>

                <div style={{ background: "#f0f9ff", borderRadius: "12px", padding: "20px", color: "#0c4a6e", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.05)", border: "1px solid #bae6fd", textAlign: "left" }}>

                  <div style={{ fontSize: "11px", fontWeight: "700", textTransform: "uppercase", color: "#0369A1", letterSpacing: "0.5px" }}>Total Runs</div>

                  <div style={{ fontSize: "28px", fontWeight: "800", marginTop: "8px" }}>{reportsList.length}</div>

                </div>

                <div style={{ background: "#ecfdf5", borderRadius: "12px", padding: "20px", color: "#064e3b", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.05)", border: "1px solid #86efac", textAlign: "left" }}>

                  <div style={{ fontSize: "11px", fontWeight: "700", textTransform: "uppercase", color: "#047857", letterSpacing: "0.5px" }}>Passed Runs</div>

                  <div style={{ fontSize: "28px", fontWeight: "800", marginTop: "8px" }}>{reportsList.filter(run => run.status === "passed").length}</div>

                </div>

                <div style={{ background: "#fef2f2", borderRadius: "12px", padding: "20px", color: "#881337", boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.05)", border: "1px solid #fda4af", textAlign: "left" }}>

                  <div style={{ fontSize: "11px", fontWeight: "700", textTransform: "uppercase", color: "#BE123C", letterSpacing: "0.5px" }}>Failed Runs</div>

                  <div style={{ fontSize: "28px", fontWeight: "800", marginTop: "8px" }}>{reportsList.filter(run => run.status !== "passed").length}</div>

                </div>

              </div>



              <div className="table-card">

                <div className="panel-header-row" style={{ borderBottom: "1px solid #f1f5f9", paddingBottom: "12px", marginBottom: "16px" }}>

                  <div style={{ textAlign: "left" }}>

                    <h3 className="panel-header-title" style={{ marginBottom: 0 }}>Execution Test Runs</h3>

                    <p style={{ color: "var(--text-muted)", fontSize: "13px", marginTop: "4px" }}>Monitor execution passes, failures, and auto-healed browser runs.</p>

                  </div>

                  <button

                    className="btn-primary"

                    onClick={() => {

                      const defaultProj = (testCaseRepo && Object.keys(testCaseRepo).length > 0) ? Object.keys(testCaseRepo)[0] : "Qintra";
                      setRunProject((activeRepoProject === "Rabbit" ? "Qintra" : activeRepoProject) || defaultProj);

                      const firstCase = (testCaseRepo && testCaseRepo[activeRepoProject || defaultProj] && testCaseRepo[activeRepoProject || defaultProj][0]) ? testCaseRepo[activeRepoProject || defaultProj][0].filename : "";

                      setRunTestCase(firstCase);

                      setRunTriggeredBy(currentUser?.email || "");

                      setShowStartRunModal(true);

                    }}

                    style={{ margin: 0, padding: "10px 18px", height: "40px", background: "var(--primary)" }}

                  >

                    🚀 Trigger Run

                  </button>

                </div>



                <table className="projects-table">
                  <thead>
                    <tr>
                      <th>Execution ID</th>
                      <th>Scenario Name</th>
                      <th>Go to Case</th>
                      <th>Suite Type</th>
                      <th>Ran By</th>
                      <th>Duration</th>
                      <th>Result Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedReportsList.length === 0 ? (
                      <tr>
                        <td colSpan="8" style={{ textAlign: "center", padding: "20px", color: "var(--text-muted)" }}>
                          No runs found. Go to Generator page and execute a test!
                        </td>
                      </tr>
                    ) : (
                      sortedReportsList.map((run, index) => {
                        const isPassed = run.status === "passed";
                        return (
                          <tr key={run.run_id || index}>
                            <td style={{ fontFamily: "monospace", fontSize: "12px" }}>{formatRunId(run.run_id)}</td>
                            <td style={{ fontWeight: "600" }}>
                              {run.test_case
                                ? run.test_case.replace(".json", "").replace(/_/g, " ")
                                : `On-the-fly Run (${run.timestamp})`}
                            </td>
                            <td>
                              {run.test_case ? (
                                <button
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    const proj = (run.project === "Rabbit" ? "Qintra" : run.project) || "Qintra";
                                    const uniqueId = `${proj}::${run.test_case}`;
                                    setActiveRepoProject(proj);
                                    setSaveProject(proj);
                                    setExpandedCodeTestId(uniqueId);
                                    setExpandedRepoTab(prev => ({ ...prev, [uniqueId]: "code" }));
                                    setPage("testcases");
                                    if (typeof fetchTestCases === "function") {
                                      fetchTestCases();
                                    }
                                  }}
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "4px",
                                    padding: "4px 10px",
                                    fontSize: "11.5px",
                                    fontWeight: "700",
                                    color: "#ffffff",
                                    backgroundColor: "var(--primary)",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                    boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
                                    transition: "all 0.2s"
                                  }}
                                  onMouseEnter={(e) => { e.currentTarget.style.filter = "brightness(0.9)"; }}
                                  onMouseLeave={(e) => { e.currentTarget.style.filter = "none"; }}
                                  title="Go to Test Case View"
                                >
                                  ➡️ Go to Case
                                </button>
                              ) : (
                                <span style={{ color: "var(--text-muted)", fontSize: "12px" }}>-</span>
                              )}
                            </td>

                            <td style={{ textTransform: "capitalize" }}>{run.type}</td>

                            <td>{run.triggered_by || "NR Patnaik"}</td>

                            <td style={{ fontFamily: "monospace" }}>{run.duration ? `${run.duration}s` : "00:01:15"}</td>

                            <td>

                              <span className={`table-status-badge ${isPassed ? "healthy" : "risk"}`} style={{ background: isPassed ? "#ecfdf5" : "#ffd7d7ff", color: isPassed ? "#10b981" : "#ef4444" }}>

                                {isPassed ? "Passed" : "Failed"}

                              </span>

                            </td>

                            <td>

                              <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>

                                <button

                                  onClick={() => playRunVideo(run.run_id, run.type)}

                                  style={{

                                    background: "rgba(59, 130, 246, 0.08)",

                                    border: "1px solid rgba(59, 130, 246, 0.2)",

                                    borderRadius: "6px",

                                    color: "#3b82f6",

                                    fontWeight: "700",

                                    cursor: "pointer",

                                    padding: "6px 12px",

                                    fontSize: "12px",

                                    display: "inline-flex",

                                    alignItems: "center",

                                    gap: "6px",

                                    transition: "all 0.2s"

                                  }}

                                  onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(59, 130, 246, 0.15)"; }}

                                  onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(59, 130, 246, 0.08)"; }}

                                >

                                  🎥 Video

                                </button>

                                <button

                                  onClick={() => downloadLog(run.run_id, run.type)}

                                  style={{

                                    background: "rgba(71, 85, 105, 0.08)",

                                    border: "1px solid rgba(71, 85, 105, 0.2)",

                                    borderRadius: "6px",

                                    color: "#475569",

                                    fontWeight: "700",

                                    cursor: "pointer",

                                    padding: "6px 12px",

                                    fontSize: "12px",

                                    display: "inline-flex",

                                    alignItems: "center",

                                    gap: "6px",

                                    transition: "all 0.2s"

                                  }}

                                  onMouseEnter={(e) => { e.currentTarget.style.background = "rgba(71, 85, 105, 0.15)"; }}

                                  onMouseLeave={(e) => { e.currentTarget.style.background = "rgba(71, 85, 105, 0.08)"; }}

                                >

                                  📥 Download

                                </button>

                              </div>

                            </td>

                          </tr>

                        );

                      })

                    )}

                  </tbody>

                </table>

              </div>

            </div>


  );
}

